import { IconButton } from '@mui/material';

import Icon from '../Icon';
import { TableBodyCell } from '../table-cells/TableCells';

const TableRowButtons = ({
  isEditable,
  isPDC,
  isSaveDisabled = false,
  onSave,
  onDialogOpen,
  switchToEditMode,
  declineEditMode,
}) => {
  if (isEditable) {
    return (
      <>
        <TableBodyCell sx={{ width: '72px' }}>
          <IconButton
            onClick={onSave}
            disabled={isSaveDisabled}
            sx={{
              color: isSaveDisabled ? '#C2CFE0' : 'success.light',
              '&:hover': { color: 'success.light' },
            }}
          >
            <Icon id="accept" viewBox="0 0 22 22" />
          </IconButton>
        </TableBodyCell>
        <TableBodyCell sx={{ width: '72px' }}>
          <IconButton
            onClick={declineEditMode}
            sx={{ color: 'error.main', '&:hover': { color: 'error.main' } }}
          >
            <Icon id="close" viewBox="0 0 22 22" />
          </IconButton>
        </TableBodyCell>
      </>
    );
  }

  return (
    <>
      <TableBodyCell sx={{ width: '72px' }}>
        <IconButton onClick={switchToEditMode}>
          <Icon id="edit" />
        </IconButton>
      </TableBodyCell>
      <TableBodyCell sx={{ width: '72px' }}>
        {isPDC ? null : (
          <IconButton onClick={onDialogOpen}>
            <Icon id="delete" />
          </IconButton>
        )}
      </TableBodyCell>
    </>
  );
};

export default TableRowButtons;
